module.exports = __webpack_public_path__ + "static/img/weather41.0837bc32.png";